import React, { useState } from 'react'
import { useAuth } from '../hooks/useAuth'

export default function LoginPage() {
  const { signIn } = useAuth()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  async function handleSubmit(e) {
    e.preventDefault()
    setError('')
    setLoading(true)
    const { error } = await signIn(email, password)
    if (error) setError('Email o password non corretti.')
    setLoading(false)
  }

  return (
    <div className="login-page">
      <div className="login-road" aria-hidden="true" />
      <svg className="login-bg-car" viewBox="0 0 600 220" aria-hidden="true">
        <path d="M40 160 Q60 110 130 100 L210 92 Q260 60 340 58 Q430 58 480 96 L540 108 Q580 120 580 150 L580 175 Q580 185 570 185 L40 185 Q30 185 30 175 Z" fill="currentColor" opacity="0.08"/>
        <circle cx="160" cy="185" r="28" fill="currentColor" opacity="0.12"/>
        <circle cx="460" cy="185" r="28" fill="currentColor" opacity="0.12"/>
      </svg>

      <div className="login-card">
        <div className="login-logo">
          <img src="/logo-diemmeci.png" alt="Diemmeci Broker" className="login-brand-logo" />
        </div>
        <div className="login-sub" style={{ textAlign: 'center' }}>Accedi al tuo account per gestire le pratiche</div>

        {error && <div className="alert alert-error">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Email <span className="req">*</span></label>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="nome@esempio.it"
              required
              autoFocus
            />
          </div>
          <div className="form-group">
            <label>Password <span className="req">*</span></label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="••••••••"
              required
            />
          </div>
          <button type="submit" className="btn btn-primary" style={{ width: '100%', justifyContent: 'center', marginTop: '0.5rem' }} disabled={loading}>
            {loading ? 'Accesso in corso...' : 'Accedi'}
          </button>
        </form>

        <p className="text-muted text-small mt-2" style={{ textAlign: 'center' }}>
          Per le credenziali contatta l'amministratore
        </p>
      </div>
    </div>
  )
}
